module.exports = __webpack_public_path__ + "img/meth.c06f953a.png";